import { render } from "./RegisterSuccessModal.vue?vue&type=template&id=8bd4f1fc&scoped=true"
import script from "./RegisterSuccessModal.vue?vue&type=script&lang=js"
export * from "./RegisterSuccessModal.vue?vue&type=script&lang=js"

import "./RegisterSuccessModal.vue?vue&type=style&index=0&id=8bd4f1fc&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/vue-code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bd4f1fc"]])

export default __exports__